import { SearchOutlined } from "@ant-design/icons";

/**
 * The strip above a list: title with the total, search box, optional filter
 * controls and the page's primary action — one component instead of the
 * markup every list page used to copy from the previous one.
 *
 * `onSearch` receives the typed text; the page debounces it as it sees fit.
 */
const TableToolbar = ({
  title,
  count,
  searchValue,
  onSearch,
  searchPlaceholder = "Type to search...",
  filters,
  action,
}) => (
  <div className="m-4 flex flex-wrap items-center justify-between gap-3">
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-lg font-bold">{`${title} (${count ?? 0})`}</span>

      <div className="relative w-full sm:w-80">
        <SearchOutlined className="absolute top-1/2 left-2 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          aria-label={`Search ${title}`}
          value={searchValue ?? ""}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={searchPlaceholder}
          className="w-full rounded-md border border-stroke bg-transparent py-3 pl-8 pr-4 outline-none focus:border-primary focus-visible:shadow-none"
        />
      </div>

      {filters}
    </div>

    {action}
  </div>
);

export default TableToolbar;
